import moment from 'moment-timezone';
import { PaymentTypeLabel } from '../../types';
import { I18n, Store } from '../../wrappers';
import Order from '../Order';
export class CashRegisterLocalizationMe {
    cashRegister;
    constructor(cashRegister) {
        this.cashRegister = cashRegister;
    }
    static availablePaymentTypes() {
        const noncashOnly = !!Store.get('tenant')?.venue?.settings.noncash_only;
        const cashPaymentTypes = [PaymentTypeLabel.cash, PaymentTypeLabel.credit_card];
        return [
            ...(!noncashOnly ? cashPaymentTypes : []),
            PaymentTypeLabel.invoice,
            PaymentTypeLabel.credit_card_business,
            PaymentTypeLabel.advance,
            PaymentTypeLabel.other_noncash,
        ].map(val => {
            return {
                key: val,
                display: I18n.t(`orders.payment_types.${val}`),
            };
        });
    }
    relevantTransactions() {
        const curDay = moment().tz('Europe/Podgorica').format('YYYY-MM-DD');
        return this.cashRegister.getTransactions().filter(transaction => {
            const issedAt = moment.utc(transaction.issued_at).tz('Europe/Podgorica');
            return issedAt.format('YYYY-MM-DD') === curDay;
        });
    }
    relevantOrders() {
        const curDay = moment().tz('Europe/Podgorica').format('YYYY-MM-DD');
        return Order.all().filter(order => {
            const lastActivityAt = moment.utc(order.last_activity_at).tz('Europe/Podgorica');
            return lastActivityAt.format('YYYY-MM-DD') === curDay && order.cash_register_id === this.cashRegister.id;
        });
    }
}
const CashRegisterLocalizationMeStatic = CashRegisterLocalizationMe;
//# sourceMappingURL=CashRegisterLocalizationMe.js.map